module.exports = __webpack_public_path__ + "static/img/knowledgeService.94160af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/knowledgeService.jpg
// module id = exVW
// module chunks = 1